import styled from '@emotion/styled';
import { Color } from '../../../features/shared/styles/Color';
import type { ITheme } from '../../themer';
import themed from '../../themer/themed';
import Responsive from '../../utils/Responsive';
import { FixedGridItem } from '../Grid';
import { Link, StyledIconLink, StyledLinkText } from '../Link';

export const QuickLinkItem = styled(FixedGridItem)<{}, ITheme>`
	margin-top: 0;
	border-radius: 4px;
	text-decoration: underline;
	* {
		color: ${Color.TextBlack};
	}
	g {
		stroke: ${Color.TextBlack} !important;
	}

	${themed(
		({ quickLink }) => `
		border-bottom: ${quickLink.item.border.width} solid ${quickLink.item.border.color};
		box-shadow: 0px calc(-1 * ${quickLink.item.border.width}) 0px 0px ${quickLink.item.border.color};
	`,
	)};
	&:hover {
		background-color: ${Color.PrimaryDefault};
		* {
			color: ${Color.TextWhite};
		}
		g {
			stroke: ${Color.TextWhite} !important;
		}
	}
	&:focus-visible {
		g {
			stroke: ${Color.TextWhite} !important;
		}
	}

	${Link},
	${StyledIconLink} {
		border-radius: 4px;
		display: flex;
		justify-content: space-between;

		> span {
			width: 100%;
			justify-content: space-between;
		}
		padding: ${themed(({ quickLink }) => quickLink.item.padding.desktop)};

		&:hover {
			padding-left: 8px;
			background-color: ${Color.PrimaryDefault};
			text-decoration-color: ${Color.TextWhite};
			* {
				color: ${Color.TextWhite};
			}
			g {
				stroke: ${Color.TextWhite} !important;
			}

			&:after {
				display: none;
			}
		}

		&:focus-visible {
			padding-left: 8px;
			outline: 2px solid #430042;
			outline-offset: -2px;
			background-color: ${Color.PrimaryDefault};
			text-decoration-color: ${Color.TextWhite};
			* {
				color: ${Color.TextWhite};
			}
			g {
				stroke: ${Color.TextWhite} !important;
			}
		}

		@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
			padding: ${themed(({ quickLink }) => quickLink.item.padding.mobile)};
		}

		svg {
			min-width: 2em;
			height: 2em;
		}
	}

	${StyledLinkText} {
		line-height: 2em;

		// IE11 fix
		display: inline-block;
		flex-grow: 1;
	}
`;
